import actionTypes from '../constants/action-types';

const setSelection = (selection) => ({
  type: actionTypes.SET_SELECTION,
  payload: {
    selection,
  },
});

export default setSelection;
